import type { PickActions } from '@core/ngrx-legacy';
import { createEntityCollectionStore } from '@core/ngrx-legacy';
import type { OAuthClient } from '@core/oauth-types';

const { actions, reducer, namespace, selectors } =
  createEntityCollectionStore<OAuthClient>()('OAuthClient');

const OAuthClientActions: PickActions<typeof actions, 'fetchOne'> = actions;

export {
  OAuthClientActions,
  reducer as OAuthClientReducer,
  namespace as OAuthClientNamespace,
  selectors as OAuthClientSelectors,
};
